import { useGetTimeZoneQuery } from '../queries/queryTyping/getTimeZone';

export const useUserTimeZone = () => {
  const { data, error, loading } = useGetTimeZoneQuery();

  if (error) {
    throw error;
  }

  return {
    ...data?.timeZone,
    loading,
  };
};
